<template>
<div class="LegalHouseDialog">
  <el-dialog title="批量消息推送" :visible.sync="dialogVisible_2" :close-on-click-modal="false" width="1200px">
    <LegalHouseMsg v-if="dialogVisible_2" :list="list" :project_id="project_id" :urge_type="urge_type" />
  </el-dialog>
</div>
</template>

<script>
import LegalHouseMsg from "./LegalHouseMsg";
export default {
  name: "LegalHouseDialog",
  components: {LegalHouseMsg},
  data(){
    return {
      dialogVisible_2: false,
      project_id:0,
      list: [],
      urge_type:0,
    }
  },
  methods: {
    showDialog(project_id,list,urge_type=0) {
      this.project_id = project_id
      this.list = list
      this.dialogVisible_2 = true
      this.urge_type=urge_type
    },
    addHouse(project_id=0,list=[],urge_type=0){
      const that = this
      let dataList = ERP.getLocalStore(`legal_house_list_${project_id}_${urge_type}`) || []
      let data_ch_md5s = dataList.map(item => item.ch_md5)

      let countObj={
        select_count:list.length,
        old_list_count:dataList.length,
        new_list_count:0,
        re_list_count:0,
        add_list_count:0
      }

      list.forEach(item => {
        if(!data_ch_md5s.includes(item.ch_md5)) {
          dataList.push(item)
          countObj.add_list_count+=1;
        }else {
          countObj.re_list_count+=1;
        }
      })
      countObj.new_list_count = dataList.length
      ERP.setLocalStore(`legal_house_list_${project_id}_${urge_type}`, dataList);
      that.$message.success(`成功添加：${countObj.add_list_count} 户，总户数：${countObj.new_list_count} 户`)
    }
  }
}
</script>

<style lang="scss" scoped>
.LegalHouseDialog{
  >>> .el-dialog__body {
    padding: 5px 20px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/msg/LegalHouseDialog.vue